// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__1INg1","Container":"App_Container__u_w8O"};